import { Injectable, inject } from '@angular/core';
import { Observable, of, shareReplay, tap, map, finalize } from 'rxjs';
import { OnboardingInitializeRequest } from '@core/models';
import { AuthService } from '../auth/auth.service';
import { OnboardingService } from './onboarding.service';

@Injectable({ providedIn: 'root' })
export class OnboardingBootstrapService {
  private readonly authService = inject(AuthService);
  private readonly onboardingService = inject(OnboardingService);
  private initializedUserIds = new Set<string>();
  private inFlightByUserId = new Map<string, Observable<void>>();

  ensureInitialized(
    request: OnboardingInitializeRequest = {},
    force = false,
    suppressGlobalFeedback = false
  ): Observable<void> {
    const session = this.authService.getSession();
    const userId = session?.userId;

    if (!userId) {
      return of(void 0);
    }

    if (!force && this.initializedUserIds.has(userId)) {
      return of(void 0);
    }

    const inFlight = this.inFlightByUserId.get(userId);
    if (inFlight) {
      return inFlight;
    }

    const request$ = this.onboardingService.initialize(request, suppressGlobalFeedback).pipe(
      tap(() => {
        this.initializedUserIds.add(userId);
      }),
      map(() => void 0),
      finalize(() => {
        this.inFlightByUserId.delete(userId);
      }),
      shareReplay(1)
    );

    this.inFlightByUserId.set(userId, request$);
    return request$;
  }
}
